import { lazy } from 'react';

import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

const PatientAssessmentPage = Loadable(lazy(() => import('pages/patient/assessment')));

const PatientRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <CommonLayout />,
      children: [
        {
          path: '/patient-assessment/:id/:token',
          element: <PatientAssessmentPage />
        }
      ]
    }
  ]
};

export default PatientRoutes;
